import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaveProgressComponent } from './wave-progress.component';

@NgModule({
    declarations: [
        WaveProgressComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        WaveProgressComponent
    ]
})
export class NcWaveProgressModule { }